import { FormControl, FormGroup } from '@angular/forms';
import { Validator } from '@vendasta/protos/ai_assistants/v1alpha1';
import { FormArrayWithDirtyTracking } from './forms';

export type ValidatorFormControls = {
  validator: FormControl<Validator | null>;
};

export class ValidatorForm extends FormGroup<ValidatorFormControls> {
  constructor(validator?: Validator) {
    super({
      validator: new FormControl(validator ?? null),
    });
  }

  toValidator(): Validator | undefined {
    return this.controls.validator.getRawValue() ?? undefined;
  }
}

export class AiValidatorsFormArray extends FormArrayWithDirtyTracking<ValidatorForm> {
  constructor(validators?: Validator[]) {
    super((validators ?? []).map((validator) => new ValidatorForm(validator)));
  }

  toValidators(): Validator[] {
    return this.controls.map((form) => form.toValidator()).filter((v): v is Validator => v !== undefined);
  }
}
